export default __webpack_public_path__ + "a6485c67a0a90ec25a65560f48549eb1.svg";